import {Mutation} from 'vuex';
import {IModuleState} from './types';

// 专案列表
export const setGroups: Mutation<IModuleState> = (state, payload) => {
    state.list.data = payload.data;
    state.list.pageNum = payload.pageNum;
    state.list.pageSize = payload.pageSize;
    state.list.total = payload.total;
    state.list.loading = !!payload.loading;
};

// 展示列表
export const setDpsPage: Mutation<IModuleState> = (state, payload) => {
    state.list.data = payload.data;
    state.list.pageNum = payload.pageNum;
    state.list.pageSize = payload.pageSize;
    state.list.total = payload.total;
    state.list.loading = !!payload.loading;
};

// 展示内容列表
export const setDpscPage: Mutation<IModuleState> = (state, payload) => {
    state.listDpsc.data = payload.data;
    state.listDpsc.pageNum = payload.pageNum;
    state.listDpsc.pageSize = payload.pageSize;
    state.listDpsc.total = payload.total;
    state.listDpsc.loading = !!payload.loading;
};

// 已删除的专案列表
export const setRestoreList: Mutation<IModuleState> = (state, payload) => {
    state.restoreList.data = payload.data;
    state.restoreList.pageNum = payload.pageNum;
    state.restoreList.pageSize = payload.pageSize;
    state.restoreList.total = payload.total;
    state.restoreList.loading = !!payload.loading;
};

// 操作日志或调整日志
export const setLogs: Mutation<IModuleState> = (state, payload) => {
    state.logs.data = payload.data;
    state.logs.pageNum = payload.pageNum;
    state.logs.pageSize = payload.pageSize;
    state.logs.total = payload.total;
    state.logs.loading = !!payload.loading;
};

// 组织下拉列表
export const setOrgs: Mutation<IModuleState> = (state, payload) => {
    state.orgs.data = payload.data;
    state.orgs.loading = !!payload.loading;
};

// 专案详情
export const setDetail: Mutation<IModuleState> = (state, payload) => {
    state.detail.data = payload.data;
    state.detail.loading = !!payload.loading;
};

// 待添加的物品列表(左库)
export const setAllMatModels: Mutation<IModuleState> = (state, payload) => {
    state.allModels.data = payload.data;
    state.allModels.pageNum = payload.pageNum;
    state.allModels.pageSize = payload.pageSize;
    state.allModels.total = payload.total;
    state.allModels.loading = !!payload.loading;
};

// 待添加的材料列表(左库)
export const setAllMatMaterials: Mutation<IModuleState> = (state, payload) => {
    state.allMaterials.data = payload.data;
    state.allMaterials.pageNum = payload.pageNum;
    state.allMaterials.pageSize = payload.pageSize;
    state.allMaterials.total = payload.total;
    state.allMaterials.loading = !!payload.loading;
};

// 专案的物品列表(右库)
export const setModels: Mutation<IModuleState> = (state, payload) => {
    state.models.data = payload.data;
    state.models.loading = !!payload.loading;
};

// 专案的材料列表(右库)
export const setMaterials: Mutation<IModuleState> = (state, payload) => {
    state.materials.data = payload.data;
    state.materials.loading = !!payload.loading;
};

// 子专案的拼装家具列表(右库)
export const setLibFurs: Mutation<IModuleState> = (state, payload) => {
    state.libFurs.data = payload.data;
    state.libFurs.loading = !!payload.loading;
};

// 专案状态字典
export const setStatusTypes: Mutation<IModuleState> = (state, payload) => {
    state.statusTypes.data = payload.data;
    state.statusTypes.raw = payload.data;
    state.statusTypes.loading = !!payload.loading;
};

// 专案的光照配置(即将废弃)
export const setEnvLight: Mutation<IModuleState> = (state, payload) => {
    state.envLight.data = payload.data;
    state.envLight.loading = !!payload.loading;
};

// 专案发布检查结果
export const setShelfCheck: Mutation<IModuleState> = (state, payload) => {
    state.shelfCheck.data = payload.data;
    state.shelfCheck.params = payload.params;
    state.shelfCheck.visible = !!payload.visible;
    state.shelfCheck.loading = !!payload.loading;
};

// 升级物品库异常结果
export const setUpgradeCheck: Mutation<IModuleState> = (state, payload) => {
    state.upgradeCheck.data = payload.data;
    state.upgradeCheck.visible = !!payload.visible;
    state.upgradeCheck.loading = !!payload.loading;
};

// 弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
    state.dialog.visible = !!payload.visible;
    state.dialog.loading = !!payload.loading;
    state.dialog.data = payload.data;
    state.dialog.type = payload.type;
};

// 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
    state.confirm.visible = !!payload.visible;
    state.confirm.loading = !!payload.loading;
    state.confirm.title = payload.title;
    state.confirm.content = payload.content;
    state.confirm.name = payload.name;
};

// 过滤配置
export const setFilters: Mutation<IModuleState> = (state, payload) => {
    state.filters.data = payload.data;
    state.filters.loading = !!payload.loading;
};

// 设置列表搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
    state.searchParams = payload;
};

// 列表搜索条件
export const setSearch: Mutation<IModuleState> = (state, payload) => {
    state.search = payload;
};

export const setDpscSearch: Mutation<IModuleState> = (state, payload) => {
    state.dpscSearch = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
    state.loading = !!payload;
};
